"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var queryablesecurable_1 = require("./queryablesecurable");
var lists_1 = require("./lists");
var fields_1 = require("./fields");
var navigation_1 = require("./navigation");
var sitegroups_1 = require("./sitegroups");
var contenttypes_1 = require("./contenttypes");
var folders_1 = require("./folders");
var roles_1 = require("./roles");
var files_1 = require("./files");
var util_1 = require("../../utils/util");
var lists_2 = require("./lists");
var siteusers_1 = require("./siteusers");
var usercustomactions_1 = require("./usercustomactions");
var odata_1 = require("./odata");
var Webs = (function (_super) {
    __extends(Webs, _super);
    function Webs(baseUrl, webPath) {
        if (webPath === void 0) { webPath = "webs"; }
        _super.call(this, baseUrl, webPath);
    }
    Webs.prototype.add = function (title, url, description, template, language, inheritPermissions, additionalSettings) {
        if (description === void 0) { description = ""; }
        if (template === void 0) { template = "STS"; }
        if (language === void 0) { language = 1033; }
        if (inheritPermissions === void 0) { inheritPermissions = true; }
        if (additionalSettings === void 0) { additionalSettings = {}; }
        var props = util_1.Util.extend({
            Description: description,
            Language: language,
            Title: title,
            Url: url,
            UseSamePermissionsAsParentSite: inheritPermissions,
            WebTemplate: template,
        }, additionalSettings);
        var postBody = JSON.stringify({
            "parameters": util_1.Util.extend({
                "__metadata": { "type": "SP.WebCreationInformation" },
            }, props),
        });
        var q = new Webs(this, "add");
        return q.post({ body: postBody }).then(function (data) {
            return {
                data: data,
                web: new Web(odata_1.extractOdataId(data), ""),
            };
        });
    };
    return Webs;
}(queryable_1.QueryableCollection));
exports.Webs = Webs;
var Web = (function (_super) {
    __extends(Web, _super);
    function Web(baseUrl, path) {
        if (path === void 0) { path = "_api/web"; }
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(Web.prototype, "webs", {
        get: function () {
            return new Webs(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "contentTypes", {
        get: function () {
            return new contenttypes_1.ContentTypes(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "lists", {
        get: function () {
            return new lists_1.Lists(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "fields", {
        get: function () {
            return new fields_1.Fields(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "availablefields", {
        get: function () {
            return new fields_1.Fields(this, "availablefields");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "navigation", {
        get: function () {
            return new navigation_1.Navigation(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "siteUsers", {
        get: function () {
            return new siteusers_1.SiteUsers(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "siteGroups", {
        get: function () {
            return new sitegroups_1.SiteGroups(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "folders", {
        get: function () {
            return new folders_1.Folders(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "userCustomActions", {
        get: function () {
            return new usercustomactions_1.UserCustomActions(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Web.prototype, "roleDefinitions", {
        get: function () {
            return new roles_1.RoleDefinitions(this);
        },
        enumerable: true,
        configurable: true
    });
    Web.prototype.createBatch = function () {
        return new odata_1.ODataBatch(this.parentUrl);
    };
    Web.prototype.getFolderByServerRelativeUrl = function (folderRelativeUrl) {
        return new folders_1.Folder(this, "getFolderByServerRelativeUrl('" + folderRelativeUrl + "')");
    };
    Web.prototype.getFileByServerRelativeUrl = function (fileRelativeUrl) {
        return new files_1.File(this, "getFileByServerRelativeUrl('" + fileRelativeUrl + "')");
    };
    Web.prototype.getList = function (listRelativeUrl) {
        return new lists_2.List(this, "getList('" + listRelativeUrl + "')");
    };
    Web.prototype.update = function (properties) {
        var _this = this;
        var postBody = JSON.stringify(util_1.Util.extend({
            "__metadata": { "type": "SP.Web" },
        }, properties));
        return this.post({
            body: postBody,
            headers: {
                "X-HTTP-Method": "MERGE",
            },
        }).then(function (data) {
            return {
                data: data,
                web: _this,
            };
        });
    };
    Web.prototype.delete = function () {
        return this.post({
            headers: {
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    Web.prototype.applyTheme = function (colorPaletteUrl, fontSchemeUrl, backgroundImageUrl, shareGenerated) {
        var postBody = JSON.stringify({
            backgroundImageUrl: backgroundImageUrl,
            colorPaletteUrl: colorPaletteUrl,
            fontSchemeUrl: fontSchemeUrl,
            shareGenerated: shareGenerated,
        });
        var q = new Web(this, "applytheme");
        return q.post({ body: postBody });
    };
    Web.prototype.applyWebTemplate = function (template) {
        var q = new Web(this, "applywebtemplate");
        q.concat("(@t)");
        q.query.add("@t", template);
        return q.post();
    };
    Web.prototype.doesUserHavePermissions = function (perms) {
        var q = new Web(this, "doesuserhavepermissions");
        q.concat("(@p)");
        q.query.add("@p", JSON.stringify(perms));
        return q.get();
    };
    Web.prototype.ensureUser = function (loginName) {
        var postBody = JSON.stringify({
            logonName: loginName,
        });
        var q = new Web(this, "ensureuser");
        return q.post({ body: postBody });
    };
    Web.prototype.availableWebTemplates = function (language, includeCrossLanugage) {
        if (language === void 0) { language = 1033; }
        if (includeCrossLanugage === void 0) { includeCrossLanugage = true; }
        return new queryable_1.QueryableCollection(this, "getavailablewebtemplates(lcid=" + language + ", doincludecrosslanguage=" + includeCrossLanugage + ")");
    };
    Web.prototype.getCatalog = function (type) {
        var q = new Web(this, "getcatalog(" + type + ")");
        q.select("Id");
        return q.get().then(function (data) {
            return new lists_2.List(odata_1.extractOdataId(data));
        });
    };
    Web.prototype.getChanges = function (query) {
        var postBody = JSON.stringify({ "query": util_1.Util.extend({ "__metadata": { "type": "SP.ChangeQuery" } }, query) });
        var q = new Web(this, "getchanges");
        return q.post({ body: postBody });
    };
    Object.defineProperty(Web.prototype, "customListTemplate", {
        get: function () {
            return new queryable_1.QueryableCollection(this, "getcustomlisttemplates");
        },
        enumerable: true,
        configurable: true
    });
    Web.prototype.getUserById = function (id) {
        return new siteusers_1.SiteUser(this, "getUserById(" + id + ")");
    };
    Web.prototype.mapToIcon = function (filename, size, progId) {
        if (size === void 0) { size = 0; }
        if (progId === void 0) { progId = ""; }
        var q = new Web(this, "maptoicon(filename='" + filename + "', progid='" + progId + "', size=" + size + ")");
        return q.get();
    };
    return Web;
}(queryablesecurable_1.QueryableSecurable));
exports.Web = Web;
